/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GeneratorStatusRepresentation,
} from '../models/index';
import {
    GeneratorStatusRepresentationFromJSON,
    GeneratorStatusRepresentationToJSON,
} from '../models/index';

export interface GetAllGeneratorStatusRequest {
    locale?: string;
}

/**
 * 
 */
export class GeneratorStatusApi extends runtime.BaseAPI {

    /**
     * Return all generator status
     */
    async getAllGeneratorStatusRaw(requestParameters: GetAllGeneratorStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GeneratorStatusRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/generator-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GeneratorStatusRepresentationFromJSON));
    }

    /**
     * Return all generator status
     */
    async getAllGeneratorStatus(locale?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GeneratorStatusRepresentation>> {
        const response = await this.getAllGeneratorStatusRaw({ locale: locale }, initOverrides);
        return await response.value();
    }

}
